import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { React, useEffect } from "react";
import { sizes } from "../approvalUtils";
import { useDispatch, useSelector } from "react-redux";
import {
	getQuotaForApproval,
	setState,
} from "./quotaModificationApprovalSlice";
import { periods } from "./quotaModificationUtils";
import { useLocation } from "react-router-dom";
import { setSaveDashboardFormState } from "../../../store/globalSlice";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
	const location = useLocation();
	const dispatch = useDispatch();
	const states = useSelector((store) => store.quotaModification);
	const {
		quotaStatusList,
		selectedQuotaStatus,
		countries,
		selectedCountry,
		selectedCountryID,
		selectedPeriod,
		searchText,
    redirectedFromDashboard
	} = states;

  useEffect(() => {
    if (redirectedFromDashboard) {
      dispatch(setSaveDashboardFormState(true));
    }
  }, []);


	useEffect(() => {
		if (location.state && redirectedFromDashboard) {
      // console.log("QuotaModification", location.state);
			dispatch(setState("selectedCountry", location.state.selectedCountry));
			dispatch(setState("selectedCountryID", location.state.selectedCountryID));
			const data = JSON.parse(localStorage.getItem("data"));
			const obj = {
				countryId: location.state.selectedCountryID,
				logedUser: data,
				period: selectedPeriod,
				quotaStatus: selectedQuotaStatus,
				searchText: searchText,
			};
			dispatch(getQuotaForApproval(obj));
		}
	}, [location]);

	// useEffect(() => {
	// 	let name = "";
	// 	// if (paramsCountryID) {
	// 	if (navigatedCountryID != "") {
	// 		if (countries.length > 0) {
	// 			name = countries.find(
	// 				(country) => country.countryID == navigatedCountryID
	// 			).countryName;

	// 			dispatch(setState("selectedCountry", name));
	// 			dispatch(setState("selectedCountryID", navigatedCountryID));
	// 		}
	// 	}
	// }, [countries]);

	function setQuotaStatus(event) {
		const status = event.target.value;
		dispatch(setState("selectedQuotaStatus", status));
	}

	function setCountry(event) {
		const country = event.target.value;
		let id = 0;
		if (country !== "All") {
			id = countries.find((c) => c.countryName === country).countryID;
		}

		dispatch(setState("navigatedCountryID", ""));
		dispatch(setState("selectedCountry", country));
		dispatch(setState("selectedCountryID", id));
	}

	function setPeriod(event) {
		const period = event.target.value;
		dispatch(setState("selectedPeriod", period));
	}
	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	function search() {
		if (selectedQuotaStatus === null || selectedQuotaStatus === "") {
			showMessage("Please select Quota status", "info");
			return;
		} else if (selectedCountryID === null || selectedCountryID === "") {
			showMessage("Please select country", "info");
			return;
		} else if (selectedPeriod === null || selectedPeriod === "") {
			showMessage("Please select period", "info");
			return;
		}
		dispatch(setState("quotaList", []));
		dispatch(setState("scenarioModificationList", null));
		dispatch(setState("selectedRowsselected", []));
		dispatch(setState("scenarioModificationList", null));
		dispatch(setState("expandedRowIndex", null));

		const data = JSON.parse(localStorage.getItem("data"));
		const obj = {
			countryId: selectedCountryID,
			logedUser: data,
			period: selectedPeriod,
			quotaStatus: selectedQuotaStatus,
			searchText: searchText,
		};
		console.log("Approval_QuotaModification_Search", obj);
		dispatch(getQuotaForApproval(obj));
	}
	function setSearchText(event) {
		let text = event.target.value;
	  
		// Remove special characters
		text = text.replace(/[^a-zA-Z0-9 ]/g, "");
	  
		//Replace multiple consecutive spaces with a single space
		text = text.replace(/\s{2,}/g, " ");
	  
		// Trim leading space
		text = text.trimStart();
		dispatch(setState("searchText", text));
	}

	return (
		<Box sx={{ mt: 4 }}>
			<Grid container columns={9} spacing={2}>
				<Grid item sm={2}>
					<FormControl>
						<InputLabel>Quota Status</InputLabel>
						<Select
							value={selectedQuotaStatus}
							label="Quota Status"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setQuotaStatus}
						>
							{quotaStatusList.map((status, index) => {
								return (
									<MenuItem key={index} value={status.value}>
										{status.value}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={2}>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							<MenuItem value={"All"}>{"All"}</MenuItem>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={2}>
					<FormControl>
						<InputLabel>Period</InputLabel>
						<Select
							value={selectedPeriod}
							label="Period"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setPeriod}
						>
							{periods.map((period, index) => {
								return (
									<MenuItem key={index} value={period.key}>
										{period.value}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item sm={2}>
					<TextField
						placeholder="Type your search"
						inputProps={{
							sx: {
								p: 2,
								width: selectWidth,
								height: selectHeight,
							},
						}}
						value={searchText}
						onChange={setSearchText}
					/>
				</Grid>

				<Grid item sm={1}>
					<Button
						startIcon={<ManageSearchIcon />}
						sx={{
							bgcolor: "darkred.light",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							"&:hover": {
								bgcolor: "darkred.main",
								color: "white.main",
							},
						}}
						onClick={search}
					>
						Search
					</Button>
				</Grid>
			</Grid>
		</Box>
	);
}
